import type * as React from "react";

import classNames from "classnames";

import { type Variant, ProgressBar } from "../../ProgressBar/ProgressBar";
import { PlainTooltip } from "../../Tooltip/PlainTooltip/PlainTooltip";

interface IProgressBarContainer {
    valuePercents: string;
    visits: number | boolean | string;
    progressBarWidth: number;
    innerColor?: string;
    height?: number;
    tooltipDisplayText?: string;
    layout?: "row" | "column";
    variant?: Variant;
}
export const ProgressBarContainer: React.FC<IProgressBarContainer> = ({
    valuePercents,
    visits,
    progressBarWidth,
    innerColor,
    height,
    tooltipDisplayText = "referred visits",
    layout = "row",
    variant,
}) => {
    const classes = classNames("swTable-progressBar", {
        "swTable-progressBar-column": layout === "column",
    });
    return (
        <div className={classes}>
            <span className="min-value">{valuePercents}</span>
            <PlainTooltip
                cssClass={"plainTooltip-element plainTooltip-element--header"}
                placement={"top"}
                text={`${visits} ${tooltipDisplayText}`}
                enabled={visits !== false}
            >
                <div className="u-full-width">
                    <ProgressBar
                        width={progressBarWidth}
                        innerColor={innerColor}
                        height={height}
                        variant={variant}
                    />
                </div>
            </PlainTooltip>
        </div>
    );
};
ProgressBarContainer.displayName = "ProgressBarContainer";
